module.exports = __webpack_public_path__ + "static/media/Pulse Module 5.af689b40.jpg";